import BaseTooltip from 'components/BaseTooltip'
import PlusIcon from 'mdi-react/PlusIcon'
import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { Button, Hidden } from '@mui/material'
import Fab from '@mui/material/Fab'
import { withStyles, WithStyles } from '@mui/styles'

import { openNewPersonForm } from '../../duck/actions'
import styles from './AddPersonButton.style'

const AddPersonButton: React.SFC<AddPersonButtonProps & WithStyles<typeof styles>> = ({ classes, onClick }) => {
  const mobileButton = (
    <Hidden mdUp>
      <BaseTooltip title="Add person">
        <Fab color="secondary" aria-label="Add person" className={classes.fabButton} onClick={onClick}>
          <PlusIcon />
        </Fab>
      </BaseTooltip>
    </Hidden>
  )

  const desktopAndTabletButton = (
    <Hidden smDown>
      <Button variant="contained" color="secondary" size="small" aria-label="Add person" onClick={onClick}>
        <PlusIcon size={16} className={classes.buttonIcon} />
        Add person
      </Button>
    </Hidden>
  )

  return (
    <>
      {mobileButton}
      {desktopAndTabletButton}
    </>
  )
}

type AddPersonButtonProps = {
  onClick: () => any
}

export default compose<AddPersonButtonProps & WithStyles<typeof styles>, {}>(
  connect(undefined, {
    onClick: openNewPersonForm,
  }),
  withStyles(styles)
)(AddPersonButton)
